import { create } from "zustand";
import {
  ILoadingProgress,
  IRender,
  IsFormData,
  IsHomePageTypesButton,
  IAccountDropdown,
  ISidebar,
  IQrListModal,
} from "@/types/stateTypes";
import {
  useDownloadModalStateType,
  IFolderRename,
  IQrDrawer,
  ISignUpModal,
  Loading,
  LoadingForType,
  LoadingPreview,
  QrCodePreviewOnMobileType,
  RequireRegisterType,
  FolderPopupStateType,
  FolderDetailsStateType,
} from "@/types/all.types";
import { createJSONStorage, persist } from "zustand/middleware";
import { landingPageTypes } from "@/constant";
import { cookiePersistStorage } from "@/helper/common.helper";

export const useRender = create<IRender>((set) => ({
  isRender: Math.random() * 100,
  setRender: (val) => {
    set({
      isRender: val,
    });
  },
}));

export const useSignUpModal = create<ISignUpModal>((set, get) => ({
  isTriedDownload: false,
  isSignUpModal: false,
  isSignUpPopup: false,
  isTempTrigger: false,
  setIsTriedDownload(result) {
    set({ isTriedDownload: result });
  },
  setIsTempTrigger: () => {
    set({
      isTempTrigger: !get().isTempTrigger,
    });
  },
  setIsSignUpModal: (val) => {
    set({
      isSignUpModal: val,
    });
  },
  setIsSignUpPopup: (val) => {
    set({
      isSignUpPopup: val,
    });
  },
}));

export const useRegisterRequired = create<RequireRegisterType>((set) => ({
  isTypeRequireRegister: false,
  setIsTypeRequireRegister: (val: boolean) => {
    set({ isTypeRequireRegister: val });
  },
}));

export const useHomePageTypesButton = create<IsHomePageTypesButton>((set) => ({
  homePageTypesButton: landingPageTypes,
  filteredHomePageTypesButton: landingPageTypes,
  isSteps: false,
  setFilterHomePageTypesButton: (val) =>
    set((state) => {
      let types = [...landingPageTypes];

      if (!val) {
        return { ...state, filteredHomePageTypesButton: types };
      }

      const filtered = types.find((e) => e.type === val);

      if (!filtered) {
        return { ...state, filteredHomePageTypesButton: types };
      }

      return {
        ...state,
        filteredHomePageTypesButton: [
          filtered,
          ...types.filter((item) => item.type !== filtered.type),
        ],
      };
    }),
}));

export const useIsloading = create<Loading>((set) => ({
  isLoadingApi: false,
  isDebounceLoading: false,
  setDebounceLoading: (val) => set({isDebounceLoading: val}),
  setIsloading: (val) => set({ isLoadingApi: val }),
}));

export const useIsLoadingType = create<LoadingForType>((set) => ({
  isLoadingType: true,
  setIsloadingType: (val) => set({ isLoadingType: val }),
}));

export const useIsLoadingPreview = create<LoadingPreview>((set) => ({
  isLoadingPreview: true,
  setIsLoadingPreview: (val) => set({ isLoadingPreview: val }),
}));

export const useLoadingProgress = create<ILoadingProgress>((set) => ({
  loadingProgress: 0,
  setLoadingProgress: (val) => {
    set({
      loadingProgress: val,
    });
  },
}));

export const useAccountDropdown = create<IAccountDropdown>((set) => ({
  isAccountDropdown: false,
  setIsAccountDropdown: (val) => set({ isAccountDropdown: val }),
}));

export const useSidebar = create<ISidebar>((set) => ({
  isOpen: false,
  setIsOpen: (val) => set({ isOpen: val }),
}));

export const useIsFormData = create(
  persist<IsFormData>(
    (set) => ({
      isFormData: false,
      setIsFormData: (val) => {
        set((state) => {
          return { ...state, isFormData: val };
        });
      },
    }),
    {
      name: "useIsFormData",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

export const useQrListModals = create<IQrListModal>((set) => ({
  isDeleteModal: false,
  isActiveModal: false,
  isMoveFolder: false,
  isPaused: false,
  setQrListModal: (key: string, value: boolean) => {
    set((state) => {
      return { ...state, [key]: value };
    });
  },
}));

export const useQrDrawer = create<IQrDrawer>((set) => ({
  isOpenDrawer: false,
  setIsOpenDrawer: (val) => set({ isOpenDrawer: val }),
}));

export const useDownloadModalState = create<useDownloadModalStateType>((set) => ({
  isDownloadPopupOpen: false,
  setIsDownloadPopupOpen: (val) => set({ isDownloadPopupOpen: val }),
}));

export const useQrCodePreviewModalState = create<QrCodePreviewOnMobileType>((set) => ({
  isPreviewPopupOpen: false,
  setIsPreviewPopupOpen: (val) => set({ isPreviewPopupOpen: val }),
}));

export const useFolderRename = create<IFolderRename>((set) => ({
  isInputFocused: false,
  setIsInputFocused: (val: boolean) => set({ isInputFocused: val }),
}));

export const useFolderPopupState = create<FolderPopupStateType>((set) => ({
  isFolderPopupOpen: false,
  setIsFolderPopupOpen: (val) => set({ isFolderPopupOpen: val }),
}));

export const useFolderDetailsState = create<FolderDetailsStateType>((set) => ({
  folderValue: { folder_name: "", folder_id: null },
  setFolderValue: (val) => {
    set((state) => ({
      folderValue: { ...state.folderValue, ...val },
    }));
  },
}));
